//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        flowId: {
            type: String,
            default: '',
        },
        layout: {
            type: String,
            default:
                'auditUserName,auditStatus,auditStartTime,auditFinishTime',
        },
    },
    data() {
        return {
            tableData: [],
        };
    },
    watch: {
        flowId: {
            handler() {
                if (!this.flowId) {
                    return;
                }

                this.queryData();
            },
            immediate: true,
        },
    },
    methods: {
        queryData() {
            this.$get(
                `${this.$store.getters.indexUrl}/auditFlow/task`,
                {
                    flowId: this.flowId,
                },
                (data) => {
                    this.tableData = data;
                }
            );
        },
    },
};
